// User-approved vocabulary for party balances. These are not journal-side names.
export const FINANCE_TERMS = Object.freeze({
    workshop: 'لصالح الورشة',
    supplier: 'لصالح المورد',
    customer: 'لصالح العميل',
    costBearer: 'من يتحملها؟',
});

export const itemCostBearer = (item = {}) =>
    (item.customerBillable ?? item.customer_billable ?? true) ? 'customer' : 'workshop';

export const isMoneyValue = (value) => (typeof value === 'number'
    || (typeof value === 'string' && value.trim() !== '')) && Number.isFinite(Number(value));

// Legacy debit/credit fields are movement totals, not two independently owed balances.
// Require an available signed net from the partner contract; never infer it from old rows.
export const partnerBalanceDirections = (entity = {}) => {
    if (entity.financialDataAvailable !== true || !isMoneyValue(entity.netBalance))
        return { workshop: null, party: null };
    const net = Math.round(Number(entity.netBalance) * 100) / 100;
    return { workshop: Math.max(net, 0), party: Math.max(-net, 0) };
};
